export default "__VITE_ASSET__B3YDyjkU__"